import parseLinkHeader from 'parse-link-header';
import URN from '../urn';

export default (response) => {
  const p = {};
  if (response.headers.link) {
    const links = parseLinkHeader(response.headers.link);
    if (links.prev) {
      p.prev = {
        url: links.prev.url,
        urn: links.prev.urn,
        ref: new URN(links.prev.urn).reference,
      };
    }
    if (links.next) {
      p.next = {
        url: links.next.url,
        urn: links.next.urn,
        ref: new URN(links.next.urn).reference,
      };
    }
    if (links.prev_sego) {
      p.prev_sego = {
        url: links.prev_sego.url,
        urn: links.prev_sego.urn,
        ref: new URN(links.prev_sego.urn).reference,
      };
    }
    if (links.next_sego) {
      p.next_sego = {
        url: links.next_sego.url,
        urn: links.next_sego.urn,
        ref: new URN(links.next_sego.urn).reference,
      };
    }
  }
  return p;
};
